import $ from "jquery";
import { waitForElement } from "./waitForElement";

export function ads() {
	const newsSearchPageId = "news-search-module";
	const isNewsSearch = document.getElementById(newsSearchPageId);

	if (isNewsSearch) {
		waitForElement(`#${newsSearchPageId} .news-list`).then(() => {
			initAdLinks();
		});
	} else {
		initAds();
		initAdLinks();
	}

	function initAdLinks() {
		const ads = document.querySelectorAll(".ad");

		ads.forEach((ad) => {
			const observer = new MutationObserver((mutations) => {
				mutations.forEach(() => {
					// Wait to fetch ad content from here src/main/js/news/sidebar/ads/Ad.jsx:14
					if (ad.querySelector("a")) {
						initAdLink(ad);
					}
				});
			});

			initAdLink(ad);
			observer.observe(ad, { childList: true, subtree: true });
		});

		function initAdLink(ad) {
			// Targets third-party ads only
			const link = ad.querySelector("div > a");

			link?.addEventListener("click", (e) => {
				e.preventDefault();
				window.open(link.href, "_blank");
			});
		}
	}

	function initAds() {
		const ads = document.querySelectorAll('[id^="ad_wrapper_"]');
		let isMobile = window.innerWidth < 576;

		// If zones exist
		if (ads.length > 0) {
			renderAds();

			window.addEventListener("resize", () => {
				const isMobileAfterResize = window.innerWidth < 576;

				if (isMobile !== isMobileAfterResize) {
					isMobile = isMobileAfterResize;
					renderAds();
				}
			});
		} else {
			const adContainers = document.querySelectorAll(".ad-wrapper");
			adContainers.forEach((adContainer) =>
				adContainer.classList.add("hidden"),
			);
		}

		function renderAds() {
			ads.forEach((ad) => {
				const mobileAdWrapperClass = "mobile-only";
				const desktopAdWrapperClass = "desktop-only";
				const isMobileOnlyAd =
					ad.parentElement.classList.contains(mobileAdWrapperClass);
				const isDesktopOnlyAd = ad.parentElement.classList.contains(
					desktopAdWrapperClass,
				);

				if (isMobileOnlyAd) {
					isMobile && fetchAd(ad, mobileAdWrapperClass);
					return;
				}

				if (isDesktopOnlyAd) {
					!isMobile && fetchAd(ad, desktopAdWrapperClass);
					return;
				}

				fetchAd(ad);
			});
		}

		function fetchAd(ad, adWrapperClass = "") {
			const code = ad.getAttribute("id").replace("ad_wrapper_", "");
			$.get(`/api/v1/slots/${code}`).done((data) => {
				const content = data?.html
					?.replace(/\r?\n|\r/g, "")
					.replace(/"/g, "")
					.trim();
				const $contentContainer = $(
					`${adWrapperClass && "." + adWrapperClass} #ad_wrapper_${code}`,
				);
				$contentContainer.html(content);
			});
			hideAdIfEmpty(ad);
		}

		// If zone exists but ad is not fetched
		function hideAdIfEmpty(ad) {
			const adWrapper = ad.closest(".ad-wrapper");

			if (!adWrapper) {
				return;
			}

			adWrapper.classList.add("hidden");

			const observer = new MutationObserver((mutations) => {
				mutations.forEach(() => {
					if (
						ad.querySelector('div[id^="placement_"]').children
							.length > 0
					) {
						adWrapper.classList.remove("hidden");
					}
				});
			});

			observer.observe(ad, { childList: true, subtree: true });
		}
	}
}
